import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_FAILURE:
      return {
        title: t('message.title.error.get.hazard.statement.list'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_FAILURE:
      return {
        title: t('message.title.error.get.euh.statement.list'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
